import ExpandToggleCell from 'components/Cells/ExpandToggleCell';
import { ServiceMetricsDataCellProps } from '../types';

const ServiceMetricsExpandToggleCell = ({
  targetServiceId,
  _customRowProps,
}: ServiceMetricsDataCellProps) => {
  const { expandedIds, onToggleExpand } = _customRowProps;
  const isExpanded = expandedIds?.has(targetServiceId);

  return (
    <ExpandToggleCell
      isExpanded={!!isExpanded}
      onToggle={() => onToggleExpand?.(targetServiceId)}
      ariaLabel={`Expand integration ${targetServiceId} details`}
    />
  );
};

export default ServiceMetricsExpandToggleCell;
